import { EmojiType, TWEmojiType, IHeyboxEmojiGroup, LocalHeyboxEmoji } from './type'
import { getHeyboxEmojis } from '_api/other'
import { integrationMeme } from '_api/integration'
import store from "@/store";
import { CUSTOM_EMOJI_TYPE } from '@/common/constants/emoji-upload';

class EmojiLoader {
  constructor() {
    
  }

  async loadEmojiModule(type: 'heybox' | 'twemoji' | 'custom', detailType?: string) {
    if (!type) {
      return Promise.resolve(null)
    }
    if (type === 'heybox') {
      return await this.loadHeyboxEmoji()
    } else if (type === 'twemoji') {
      return await this.loadTwemoji(detailType)
    } else if (type === 'custom') {
      return await this.loadCustomEmoji()
    }
  }
  async loadHeyboxEmoji () {
    let heyboxEmojis: {
      cube: LocalHeyboxEmoji[],
      heygirl: LocalHeyboxEmoji[],
      sticker: LocalHeyboxEmoji[]
    } = {
      cube: [],
      heygirl: [],
      sticker: []
    }
    try {
      const { data } = await getHeyboxEmojis()
      if (data.status === 'ok') {
        const emoji_groups: IHeyboxEmojiGroup[] = data.result.emoji_groups
        for (let d of emoji_groups) {
          if (d.emojis) {
            const temp: LocalHeyboxEmoji[] = d.emojis.map(v => {
              return {
                name: v.code,
                url: v.img,
                type: d.type === 2 ? 'heygirl' : 'cube'
              }
            })
            if (d.group_code === 'cube') {
              heyboxEmojis.cube.push(...temp)
            } else if (d.group_code === 'heygirl') {
              heyboxEmojis.heygirl.push(...temp)
            } else if (d.type === 2) {
              heyboxEmojis.sticker.push(...temp)
            }
          }
        }
      }
    } catch (error) {
      console.error(error)
    }
    return heyboxEmojis
  }
  async loadTwemoji (type?: string) {
    if (type) {
      const module = await import(`./twemojis/${TWEmojiType[type]}`)
      return module.default
    }
    const res = {}
    for (let key in TWEmojiType) {
      const module = await import(`./twemojis/${TWEmojiType[key]}`)
      res[TWEmojiType[key]] = module.default
    }
    return res
  }
  async loadCustomEmoji () {
    let res = await integrationMeme({_notip: true}, {
      paths: this.getFilterMemePaths()
    })
    if (res.data.status === 'ok') {
      const { meme_filter, memes, rooms } = res.data.result
      this.filterRecentMeme(meme_filter)
      return {
        emoji: memes.emoji,
        sticker: memes.sticker,
        rooms,
      }
    }
    return null
  }
  // 获取最近表情包的path列表，用于获取其中没被数美封禁的表情（过滤掉被封禁的最近表情）
  private getFilterMemePaths() {
    let { recent_emojis_small_v4 } = store.getters.setting_data
    let paths = []
    recent_emojis_small_v4.forEach(v => {
      if (v.type?.indexOf(CUSTOM_EMOJI_TYPE) === 0) {
        let path = this.getRecentMemePath(v)
        if (!paths.includes(path)) {
          paths.push(path)
        }
      }
    })
    return paths
  }
  private getRecentMemePath(v: any) {
    let path: string = ''
    if (v.path) {
      path = v.path
    } else {
      try {
        const url = v.url.split('?')[0]
        const split = url.split('/')
        path = split[split.length - 1].split('.')[0]
      } catch (e) {
        console.log(e)
      }
    }
    return path
  }
  // 过滤近期使用表情中被数美的内容
  private filterRecentMeme(meme_filter: string[]) {
    let filterFunc = (v: any) => {
      if (v.type?.indexOf(CUSTOM_EMOJI_TYPE) === 0) {
        let path = this.getRecentMemePath(v)
        return meme_filter.includes(path)
      }
      return true
    }
    let { recent_emojis_small_v4 } = store.getters.setting_data
    recent_emojis_small_v4 = recent_emojis_small_v4.filter(filterFunc)
    console.log('filterRecentMeme', recent_emojis_small_v4.map(v => v.url));
    store.dispatch("SET_SETTING_DATA_PARAM", {
      recent_emojis_small_v4,
    });
  }
}

const loader = new EmojiLoader()
export default loader